<div [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between p-2">
        <div></div>
        <p class="interP m-0">{{ 'social.createPostStory' | translate }}</p>
        <mat-icon (click)="cancel()" class="xIcon material-symbols-outlined pointer">cancel</mat-icon>
    </div>

    <hr class="mb-0">

    <div class="p-3" [formGroup]="form">

        <div *ngIf="!app?.getSelectedHcpForCont()" class="d-flex mb-2">

            <img class="border-less" [src]="app.getUserImage(app?.getUserData()?.picture)" alt="User Image">

            <div class="mx-2 d-flex align-items-start">
                <div>
                    <p class="my-1 posterName">{{app?.getUserData()?.fullName | splitStringToArEn}}</p>
                    <p class="m-0 posterSpech">{{app?.getUserData()?.speciality | splitStringToArEn}}</p>
                </div>
            </div>
        </div>

        <div *ngIf="app?.getSelectedHcpForCont()" class="d-flex mb-2">

            <img class="border-less" [src]="app.getUserImage(app?.getSelectedObjHcpForCont()?.picture)" alt="User Image">

            <div class="mx-2 d-flex align-items-start">
                <div>
                    <p class="my-1 posterName">{{app?.getSelectedObjHcpForCont()?.fullName | splitStringToArEn}}</p>
                    <!-- <p class="m-0 posterSpech">{{app?.getSelectedObjHcpForCont()?.speciality | splitStringToArEn}}</p> -->
                </div>
            </div>
        </div>

        <mat-form-field class="w-100" appearance="outline">
            <mat-label> {{ 'social.whatsYourMind' | translate }} </mat-label>
            <textarea formControlName="PostText" class="h-160" autocomplete="off" type="text" matInput
                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="9"></textarea>
        </mat-form-field>

        <!-- topics selected -->
        <div>
            <p class="my-1 posterName">{{ 'social.topics' | translate }}</p>
            <div class="ess-chip-list">
                <div class="ess-chip-item" (click)="updateChips(obj?.categoryId)"
                    [class.active]="selectedChipsValues.includes(obj?.categoryId)" *ngFor="let obj of categories">
                    #{{ obj?.categoryName }}
                </div>
            </div>

        </div>
        <!-- topics selected -->


        <!-- add attach -->
        <div class="px-3">

            <div class="row">

                <div *ngIf="fileType == null || fileType == 2" class="d-flex pointer"
                    onclick="document.getElementById('getFileVideo').click()">
                    <span class="dotCirIcon"><mat-icon class="postIcons">add_a_photo</mat-icon></span>
                    <p class="postP mx-2">{{ 'social.video' | translate }}</p>
                    <input #videoInput type='file' (change)="readUrl($event)" accept="video/*" id="getFileVideo"
                        style="display:none" />
                </div>


                <hr class="my-2" *ngIf="fileType == null">

                <div *ngIf="fileType == null || fileType == 1" class="d-flex pointer"
                    onclick="document.getElementById('getFileImage').click()">
                    <span class="dotCirIcon"><mat-icon class="postIcons">image</mat-icon></span>
                    <p class="postP mx-2">{{ 'social.photo' | translate }}</p>
                    <input #photoInput type='file' (change)="readUrl($event)" accept="image/*" multiple id="getFileImage"
                        style="display:none" />
                </div>

                <hr class="my-2" *ngIf="fileType == null">

                <div *ngIf="fileType == null || fileType == 3" class="d-flex pointer" (click)="addUrlLink()">
                    <span class="dotCirIcon"><mat-icon class="postIcons">link</mat-icon></span>
                    <p class="postP mx-2">{{ 'social.Link' | translate }}</p>
                </div>

            </div>

            <div *ngIf="fileType == 1" class="row col-12 justify-content-center">
                <div class="col-3" *ngFor="let image of imagesToPreview">
                    <img loading="lazy" class="attachment-img w-webFill" [src]="image.image" />
                    <button class="btns btn w-webFill addImgBtn" (click)="removeFromImages(image)" mat-raised-button
                        type="button">{{ 'booking.Remove' | translate }}</button>
                </div>
            </div>

            <div *ngIf="fileType == 2 && imagesToPreview.length == 1">
                <div class="vid my-3">
                    <video width="400" controls>
                        <source [src]="imagesToPreview[0]?.image" type="video/mp4">
                    </video>
                </div>
                <button class="btns btn w-webFill addImgBtn" (click)="removeFromImages(imagesToPreview[0])"
                    mat-raised-button type="button">{{ 'booking.Remove' | translate }}</button>
            </div>

            <div *ngIf="fileType == 3">

                <!-- urlLink-->
                <mat-form-field class="w-100 mt-3" appearance="outline" fxFlex="auto">
                    <mat-label>{{ 'social.urlLink' | translate }}</mat-label>
                    <input (input)="urlChangeInput()" type="text" [formControl]="linkUrl" matInput>
                    <mat-icon matSuffix (click)="removeUrlLink()">close</mat-icon>
                </mat-form-field>

                <div *ngIf="linkUrl?.value && urlData">

                    <div class="card pointer" (click)="urlClicked(urlData?.url)">
                        <img [src]="urlData?.image">
                        <span class="p-3 UrlDesc">{{urlData?.description}}</span>
                    </div>

                </div>

            </div>


        </div>
        <!-- add attach -->

        <div class="mt-4 d-flex justify-content-center">
            <button [disabled]="createBtnDisable" (click)="submit()" class="btn bgMain w-70">{{ 'social.post' | translate }}</button>
        </div>

    </div>
</div>